import React from 'react';
const Link = ({ children, url }) => {
    return (React.createElement("a", { href: url, target: "_blank", rel: "noopener noreferrer" },
        React.createElement("div", { className: "flex items-center space-x-1" },
            React.createElement("span", { className: "flex-1" }, children))));
};
export default Link;
